export const ApplicationConstant = {
    ApplicationID : 7,
    clientId : 5,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
